import { useState, useContext, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CloseIcon from '@mui/icons-material/Close';
import { SettingsBarContext } from "../../context/SettingsBarContext";


const Item = ({ title, to, icon, selected, setSelected }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <MenuItem
            active={selected === title}
            style={{
                color: colors.grey[100],
            }}
            onClick={() => setSelected(title)}
            icon={icon}
        >
            <Typography>{title}</Typography>
            <Link to={to} />
        </MenuItem>
    );
};

const SettingsBar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { isSettingsBarOpen, toggleSettingsBar } = useContext(SettingsBarContext);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [selected, setSelected] = useState("Dashboard");

    return (
        (isSettingsBarOpen) ? (
            < Box
                sx={{
                    height: "100vh",
                    ".pro-sidebar": {
                        position: "absolute",
                        right: 0,
                        left: "auto",
                    },
                    "& .pro-sidebar-inner": {
                        background: `${colors.primary[400]} !important`,
                    },
                    "& .pro-icon-wrapper": {
                        backgroundColor: "transparent !important",
                    },
                    "& .pro-inner-item": {
                        padding: "5px 35px 5px 20px !important",
                    },
                    "& .pro-inner-item:hover": {
                        color: "#00b0e0 !important",
                    },
                    "& .pro-menu-item.active": {
                        color: "#00b0e0 !important",
                    },
                }
                }
            >
                <ProSidebar >
                    <Menu iconShape="square">
                        {/* LOGO AND MENU ICON */}
                        <MenuItem
                            onClick={() => toggleSettingsBar()}
                            style={{
                                margin: "10px 0 20px 0",
                                color: colors.grey[100],
                            }}
                        >
                            {
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    ml="15px"
                                >
                                    <Typography variant="h3" color={colors.grey[100]}>
                                        Settings
                                    </Typography>
                                    <IconButton onClick={() => toggleSettingsBar}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            }
                        </MenuItem>

                        {
                            <Box mb="25px">
                                <Box display="flex" justifyContent="center" alignItems="center">
                                    <SettingsOutlinedIcon fontSize="large" />
                                </Box>

                            </Box>
                        }

                        <Box paddingLeft="10%" >
                            <Item
                                title="Linked Accounts"
                                to="/connected-accounts"
                                icon={<AccountBalanceIcon />}
                                selected={selected}
                                setSelected={setSelected}
                            />

                            <Item
                                title="Settings"
                                to="/settings"
                                icon={<SettingsOutlinedIcon />}
                                selected={selected}
                                setSelected={setSelected}
                            />

                            <Item
                                title="Account Settings"
                                to="/change-account-settings"
                                icon={<ManageAccountsIcon />}
                                selected={selected}
                                setSelected={setSelected}
                            />

                        </Box>
                    </Menu>
                </ProSidebar>

            </Box >
        ) : ""
    );
};

export default SettingsBar;